import { useEffect, useState, Fragment } from 'react';
import Star from '../components/Star';
import { useNavigate, useParams } from 'react-router-dom';
import { getLang, saveResult } from '../services/MSurveyService';
import { Col, Container, Dropdown } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faGlobe } from '@fortawesome/free-solid-svg-icons'
import { en, th, contactBackSubjects } from '../Variable';
import { IconProp } from '@fortawesome/fontawesome-svg-core';

const REACT_APP_FOLLOW_DELIVERY_EN = process.env.REACT_APP_PROFILE === 'dev' ? process.env.REACT_APP_FOLLOW_DELIVERY_EN_DEV : process.env.REACT_APP_PROFILE === 'uat' ? process.env.REACT_APP_FOLLOW_DELIVERY_EN_UAT : process.env.REACT_APP_FOLLOW_DELIVERY_EN_PROD;

const REACT_APP_FOLLOW_DELIVERY_TH = process.env.REACT_APP_PROFILE === 'dev' ? process.env.REACT_APP_FOLLOW_DELIVERY_TH_DEV : process.env.REACT_APP_PROFILE === 'uat' ? process.env.REACT_APP_FOLLOW_DELIVERY_TH_UAT : process.env.REACT_APP_FOLLOW_DELIVERY_TH_PROD;

type Invalid = {
    contactName: boolean,
    mobileNumber: boolean,
    email: boolean,
    contactBackSubject: boolean
}

type PostDeliveryProps = {
    contactBack: boolean,
    bett: boolean
}

export default function PostDelivery(props: PostDeliveryProps) {
    let navigate = useNavigate();
    let params = useParams();
    const [show, setShow] = useState(props.contactBack);
    const [contactName, setContactName] = useState<string>('');
    const [mobileNumber, setMobileNumber] = useState<string>('');
    const [email, setEmail] = useState<string>('');
    const [textArea, setTextArea] = useState<string>('');
    const [invalid, setInvalid] = useState<Invalid | undefined>(undefined);
    const [starVal, setStarVal] = useState(0);
    const [custCodeParam, setCustCodeParam] = useState<string | undefined>(undefined);
    const [lang, setLang] = useState<string | null>('en');
    const [selectedBtn, setSelectedBtn] = useState<Array<number>>([]);
    const [contactBackSubject, setContactBackSubject] = useState('');

    useEffect(() => {
        const _custCode = params.custCode;
        setCustCodeParam(_custCode?.toString());
        getLang(_custCode?.toString())
            .then(res => {
                setLang(res.data);
            })
            .catch(err => {
                console.log(err);
            })
    }, [params]);


    const handleShow = () => {
        setShow(!show);
    }

    const handleTextAreaChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
        setTextArea(e.target.value);
    }

    const handleContactNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setContactName(e.target.value);
    }

    const handleMobileNumberChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setMobileNumber(e.target.value);
    }

    const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setEmail(e.target.value);
    }

    const handleContactBackSubjectChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        setContactBackSubject(e.target.value);
    }

    const validateEmail = (email: string) => {
        return String(email)
            .toLowerCase()
            .match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
    };

    const handleSubmit = async () => {
        let valid = false;
        if (show) {
            const emailValid = validateEmail(email);
            if (emailValid && contactName && mobileNumber && contactBackSubject && starVal !== 0) {
                let _invalid = {
                    email: true,
                    contactName: true,
                    mobileNumber: true,
                    contactBackSubject: true
                }
                setInvalid(_invalid);
                valid = true;
            } else {
                const _invalid = {
                    email: !emailValid ? false : true,
                    contactName: !contactName ? false : true,
                    mobileNumber: !mobileNumber ? false : true,
                    contactBackSubject: !contactBackSubject ? false : true
                }
                setInvalid(_invalid);
            }
        } else {
            valid = true;
        }
        if (!valid) {
            return;
        } else {
            let _jobDescription = '';
            selectedBtn.forEach((s, i) => {
                let temp = '';
                if (starVal < 4) {
                    temp = lang === 'en' ? en.lowShortcutBtn.split(',')[s] : th.lowShortcutBtn.split(',')[s];
                } else {
                    temp = lang === 'en' ? en.highShortcutBtn.split(',')[s] : th.highShortcutBtn.split(',')[s];
                }
                _jobDescription += temp;
                if (i !== selectedBtn.length - 1) {
                    _jobDescription += ',';
                }
            })

            let _sresult = {
                email: email,
                contactName: contactName,
                mobileNumber: mobileNumber,
                contactBackSubject: contactBackSubject,
                contactBack: show,
                comment: textArea,
                rating: starVal,
                jobDescription: _jobDescription
            }

            let data = {
                custCode: props.bett ? null : custCodeParam,
                sresult: JSON.stringify(_sresult),
                surveyName: 'Post Delivery',
                bcustCode: props.bett ? custCodeParam : null
            }

            saveResult(data)
                .then(() => {
                    if (starVal === 4 || starVal === 5) {
                        navigate(`/sp/lang=${lang}`, { replace: true });
                    } else {
                        navigate(`/s/${show ? 'contactBack' : 'noContact'}&lang=${lang}`, { replace: true });
                    }
                })
                .catch(err => {
                    console.log({ err })
                })
        }
    }

    const openInNewTab = (_type: string) => {
        if (_type === 'BUY_COUPON') {
            window.open(lang === 'en' ? process.env.REACT_APP_BUY_COUPON_EN : process.env.REACT_APP_BUY_COUPON_TH, '_blank', 'noopener,noreferrer');
        } else {
            if (custCodeParam) {
                const custCode = custCodeParam.replace('_', '/');
                let link = lang === 'en' ? REACT_APP_FOLLOW_DELIVERY_EN : REACT_APP_FOLLOW_DELIVERY_TH;
                link = link?.replace('<custCode>', custCode);
                window.open(link, '_blank', 'noopener,noreferrer');
            }
        }
    };

    const handleShortcut = (index: number) => {
        let found = selectedBtn.find(s => s === index);
        if (found !== undefined) {
            setSelectedBtn(selectedBtn.filter(s => s !== index));
        } else {
            setSelectedBtn(s => [...s, index]);
        }
    }

    const handleStarVal = (i: number) => {
        if ((starVal > 0 && starVal < 4 && i >= 4) || (starVal >= 4 && i < 4)) {
            setSelectedBtn([]);
            setTextArea('');
        }
        setStarVal(i);
    }

    return (
        <>
            <div>
                <Container>
                    <Col className='dropdown-col' lg={9}>
                        <Dropdown onSelect={(eventKey) => setLang(eventKey)}>
                            <Dropdown.Toggle>
                                <FontAwesomeIcon icon={faGlobe as IconProp} />
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                                <Dropdown.Item eventKey={'en'} active={lang === 'en'}>EN</Dropdown.Item>
                                <Dropdown.Item eventKey={'th'} active={lang === 'th'}>TH</Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>
                    </Col>
                    <form className="form">
                        <div className="form-rating">
                            <div className="form-rating__title">{lang === 'en' ? en.rateLabel : th.rateLabel}</div>
                            <Star stars={5} onSelectedChange={handleStarVal} />
                        </div>
                        {lang === 'en' &&
                            <div className="star-label">
                                {starVal === 1 ? en.oneStar :
                                    starVal === 2 ? en.twoStar :
                                        starVal === 3 ? en.threeStar :
                                            starVal === 4 ? en.fourStar :
                                                starVal === 5 ? en.fiveStar : ''}
                            </div>}
                        {lang === 'th' &&
                            <div className="star-label">
                                {starVal === 1 ? th.oneStar :
                                    starVal === 2 ? th.twoStar :
                                        starVal === 3 ? th.threeStar :
                                            starVal === 4 ? th.fourStar :
                                                starVal === 5 ? th.fiveStar : ''}
                            </div>}
                        {starVal > 0 && starVal < 4 && lang === 'en' &&
                            <div className='shortcut-div'>
                                {en.lowShortcutBtn.split(',').map((b, i) => (
                                    <>
                                        <input type="checkbox" className="btn-check" id={`en-shortcut-btn${i}`} onChange={() => handleShortcut(i)} />
                                        <label className="btn btn-outline-primary" htmlFor={`en-shortcut-btn${i}`}>{b}</label>
                                    </>
                                ))}
                            </div>}
                        {starVal > 0 && starVal < 4 && lang === 'th' &&
                            <div className='shortcut-div'>
                                {th.lowShortcutBtn.split(',').map((b, i) => (
                                    <>
                                        <input type="checkbox" className="btn-check" id={`th-shortcut-btn${i}`} onChange={() => handleShortcut(i)} />
                                        <label className="btn btn-outline-primary" htmlFor={`th-shortcut-btn${i}`}>{b}</label>
                                    </>
                                ))}
                            </div>}
                        {starVal >= 4 && lang === 'en' &&
                            <div className='shortcut-div'>
                                {en.highShortcutBtn.split(',').map((b, i) => (
                                    <Fragment key={i}>
                                        <input type="checkbox" className="btn-check" id={`shortcut-btn${i}`} onChange={() => handleShortcut(i)} />
                                        <label className="btn btn-outline-primary" htmlFor={`shortcut-btn${i}`}>{b}</label>
                                    </Fragment>
                                ))}
                            </div>}
                        {starVal >= 4 && lang === 'th' &&
                            <div className='shortcut-div'>
                                {th.highShortcutBtn.split(',').map((b, i) => (
                                    <Fragment key={i}>
                                        <input type="checkbox" className="btn-check" id={`shortcut-btn${i}`} onChange={() => handleShortcut(i)} />
                                        <label className="btn btn-outline-primary" htmlFor={`shortcut-btn${i}`}>{b}</label>
                                    </Fragment>
                                ))}
                            </div>}
                        {starVal === 0 && <div className="star-label">&nbsp;</div>}
                        {starVal !== 0 && starVal < 4 && <Col lg={{ offset: 3, span: 6 }} md={12} sm={12}>
                            <div className="form-textarea">
                                <div className="form-textarea__bread-crumbs">
                                    {lang === 'en' ? en.textAreaLabel : th.textAreaLabel}
                                </div>
                                <textarea
                                    id="textarea"
                                    rows={10}
                                    cols={45}
                                    value={textArea}
                                    onChange={handleTextAreaChange}></textarea>
                                <label htmlFor="textarea">{ }</label>
                            </div>
                        </Col>}
                        {!props.bett && !props.contactBack && <Col lg={{ offset: 3, span: 6 }} md={12} sm={12}>
                            <button className='full-width-btn' type="button" onClick={() => openInNewTab('BUY_COUPON')}>{lang === 'en' ? en.buyCouponLabel : th.buyCouponLabel}</button>
                        </Col>}
                        {!props.bett && !props.contactBack && <Col lg={{ offset: 3, span: 6 }} md={12} sm={12}>
                            <button className='full-width-btn' type="button" onClick={() => openInNewTab('DELIVERY_TRACKING')}>{lang === 'en' ? en.deliveryTrackingLabel : th.deliveryTrackingLabel}</button>
                        </Col>}
                        <Col lg={{ offset: 3, span: 6 }} md={12} sm={12}>
                            <div className="form-contact">
                                <button className='full-width-btn' type="button" onClick={handleShow}>{lang === 'en' ? en.contactBackLabel : th.contactBackLabel}</button>
                                <div className={`form-contact__inputs ${show ? 'active' : ''}`}>
                                    <label className="label" htmlFor="contactName">{lang === 'en' ? en.contactNameLabel : th.contactNameLabel}<span className='required-star'>*</span></label>
                                    <input
                                        className={`${invalid && invalid.contactName === false ? 'error' : ''}`}
                                        id="contactName"
                                        type="text"
                                        value={contactName}
                                        onChange={handleContactNameChange} />
                                    <label className="label" htmlFor="mobileNumber">{lang === 'en' ? en.mobileLabel : th.mobileLabel}<span className='required-star'>*</span></label>
                                    <input
                                        className={`${invalid && invalid.mobileNumber === false ? 'error' : ''}`}
                                        id="mobileNumber"
                                        type="number"
                                        placeholder="0899999999"
                                        value={mobileNumber}
                                        onChange={handleMobileNumberChange} />
                                    <label className="label" htmlFor="email">{lang === 'en' ? en.emailLabel : th.emailLabel}<span className='required-star'>*</span></label>
                                    <input
                                        className={`${invalid && invalid.email === false ? 'error' : ''}`}
                                        id="email"
                                        type="text"
                                        value={email}
                                        onChange={handleEmailChange} />
                                    <label className="label" htmlFor="contactBackSubjects">{lang === 'en' ? en.contactBackSubjectLabel : th.contactBackSubjectLabel}<span className='required-star'>*</span></label>
                                    <select
                                        className={`${invalid && invalid.contactBackSubject === false ? 'error' : ''}`}
                                        id="contactBackSubjects"
                                        value={contactBackSubject}
                                        onChange={handleContactBackSubjectChange}>
                                        <option value={''} defaultValue=''></option>
                                        {contactBackSubjects.map((c, i) => (
                                            <option key={i} value={lang === 'en' ? c.en : c.th}>{lang === 'en' ? c.en : c.th}</option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                        </Col>
                        <button className={textArea === '' && starVal === 0 && !show ? 'form-button__submit disabled' : 'form-button__submit'} type="button" onClick={handleSubmit} disabled={textArea === '' && starVal === 0 && !show}>{lang === 'en' ? en.submitButtonLabel : th.submitButtonLabel}</button>
                    </form>
                </Container>
                <footer>
                    <div className="footer-info">
                        <div className="footer-info__info">{lang === 'en' ? en.inquiriesLabel : th.inquiriesLabel}</div>
                        <div className="footer-info__wrapper">
                            <a href={`tel:${process.env.REACT_APP_TEL}`} className="footer-info__number">
                                <div className={`number-${lang}`}>02-712-7272</div>
                            </a>
                            <a href={`mailto:${process.env.REACT_APP_EMAIL}`} className="footer-info__email">
                                <div className={`email-${lang}`}>info@sprinkle-th.com</div>
                            </a>
                            <a href={process.env.REACT_APP_LINE} className="footer-info__line">
                                <div className={`line-${lang}`}>@sprinklewater</div>
                            </a>
                        </div>
                    </div>
                    <div className="footer-copywriter">&#169; {lang === 'en' ? en.copyrightsLabel : th.copyrightsLabel}</div>
                </footer>
            </div>
        </>
    )
}